import avatar from '@/assets/avatar.png';
import { Link } from 'react-router-dom';

const CollectionBanner = () => {
  return (
    <section className="flex flex-col justify-start  sm:flex-row gap- sm:gap-12 mt-0 sm:mt-6 mb-12">
      <div className="max-w-32">
        <img
          src={avatar}
          alt="Collection dashboard preview"
          className="rounded-full w-20 sm:w-64 h-auto min-h-16 object-cover"
          onError={e => {
            console.error('Image failed to load:', e);
          }}
        />
      </div>
      <div>
        <h1 className="text-2xl md:text-4xl font-extrabold leading-tight mt-2 mb-4">
          My random internet finds!
        </h1>
        <p className="text-muted-foreground text-lg">
          I collect stuff I find interesting/useful online—and share some here.
          <br />
          Maybe you'll find something you like.
          <br />
          If you want to collect your own stuff, checkout{' '}
          <Link to="https://kalamu.app/collections" target="_blank" className="underline">
            kalamu.app
          </Link>
          .
        </p>
      </div>
    </section>
  );
};

export default CollectionBanner;
